module.exports = __webpack_public_path__ + "img/ico_corporacionesMunicipalidadesRecurso.f0b32f08.png";